<template>
  <div>
    <div class="dh-frame" :class="{ 'dh-frame--fluid': fluid, 'dh-frame--spine-nav': showSpineNav }" :style="frameStyle" @click="frameClicked">
      <div v-if="fluid" class="dh-frame-spine">
        <div class="dh-mini-day" aria-hidden="true">
          <span class="dh-mini-day__dow">{{ dayAbbrev }}</span>
          <span class="dh-mini-day__num">{{ dayNumber }}</span>
        </div>
        <div v-if="showSpineNav" class="dh-spine-nav">
          <button
            type="button"
            class="dh-spine-nav__btn"
            :class="{ 'dh-spine-nav__btn--review': emphasizeReceipt }"
            @click.stop="$emit('view-receipt')"
          >
            {{ receiptNavLabel }}
          </button>
          <button
            type="button"
            class="dh-spine-nav__btn"
            :class="exitNavIsCancel ? 'dh-spine-nav__btn--cancel' : 'dh-spine-nav__btn--done'"
            @click.stop="$emit('cancel-order')"
          >
            {{ exitNavLabel }}
          </button>
        </div>
        <h3 class="dh-frame-title dh-frame-title--bookend" :style="h3style">{{ borderTitle }}</h3>
      </div>
      <div v-if="fluid" class="dh-frame-main">
        <div v-if="dayTitle || dayDescription" class="dh-day-theme">
          <p v-if="dayTitle" class="dh-day-theme__title">{{ dayTitle }}</p>
          <p v-if="dayDescription" class="dh-day-theme__desc">{{ dayDescription }}</p>
        </div>
        <div v-if="choices" class="dh-body" :style="bodyStyle">
          <div v-for="(choice,cindex) in choices" :key="cindex">
            <div class="dh-category-title shadow" :style="bodySeperatorStyle">{{choice.title}}</div>
            <ul
              v-for="(item,index) in choice.items"
              :key="index"
              class="dh-item"
              :class="{ 'dh-item--in-order': itemQty(item) > 0 }"
              @click="addItemToOrder(item,choice.usePriceLevel)"
            >
              <li class="dh-item-head">
                <span class="dh-item-title">{{ item.title }}</span>
                <span v-if="formatItemPrice(item, choice.usePriceLevel)" class="dh-item-price">{{ formatItemPrice(item, choice.usePriceLevel) }}</span>
                <span v-if="itemQty(item) > 0" class="dh-item-qty" aria-label="Quantity ordered">
                  <button
                    v-if="!disabled"
                    type="button"
                    class="dh-item-qty__btn"
                    aria-label="Remove one"
                    @click.stop="removeOneFromOrder(item.itemNumber)"
                  >
                    −
                  </button>
                  <span class="dh-item-qty__count">×{{ itemQty(item) }}</span>
                </span>
              </li>
              <li v-if="item.description" class="dh-item-description">
                {{ item.description }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <template v-else>
        <h3 class="dh-frame-title" :style="h3style">{{ borderTitle }}</h3>
        <h4 class="dh-day-number">{{ dayNumber }}</h4>
      </template>
      <template v-if="!fluid">
        <div v-if="choices" class="dh-body" :style="bodyStyle">
          <div v-for="(choice,cindex) in choices" :key="cindex">
            <div class="dh-category-title shadow" :style="bodySeperatorStyle">{{choice.title}}</div>
            <ul
              v-for="(item,index) in choice.items"
              :key="index"
              class="dh-item"
              :class="{ 'dh-item--in-order': itemQty(item) > 0 }"
              @click="addItemToOrder(item,choice.usePriceLevel)"
            >
              <li class="dh-item-head">
                <span class="dh-item-title">{{ item.title }}</span>
                <span v-if="formatItemPrice(item, choice.usePriceLevel)" class="dh-item-price">{{ formatItemPrice(item, choice.usePriceLevel) }}</span>
                <span v-if="itemQty(item) > 0" class="dh-item-qty" aria-label="Quantity ordered">
                  <button
                    v-if="!disabled"
                    type="button"
                    class="dh-item-qty__btn"
                    aria-label="Remove one"
                    @click.stop="removeOneFromOrder(item.itemNumber)"
                  >
                    −
                  </button>
                  <span class="dh-item-qty__count">×{{ itemQty(item) }}</span>
                </span>
              </li>
              <li v-if="item.description" class="dh-item-description">
                {{ item.description }}
              </li>
            </ul>
          </div>
        </div>
      </template>
    </div>
  </div>

</template>
<script>

  import { CalendarDay } from '@/components';
  import Currency        from "currency.js";
  import Moment          from "moment";
  import { MEAL_CALENDAR_CHROME_DOW } from '@/utils/mealDayColors';

  export default {

    props     : {
      orderDate: {type: [ Date, String, Object ], default: null},
      title    : {type: String, default: ""},
      dayTitle : {type: String, default: ""},
      dayDescription: {type: String, default: ""},

      color             : {type: String, default: "#e3a03b"},
      textColor         : {type: String, default: "white"},
      seperatorTextColor: {type: String, default: "black"},
      seperatorColor    : {type: String, default: "gray"},
      fontSize          : {type: String, default: "medium"},
      borderFontSize    : {type: String, default: "2em"},
      choices           : {type: Array, default: () => []},

      priceLevel: {type: Number, default: 0},
      fnGetOrder: {type: Function, default: null},
      orderItems: { type: Array, default: () => [] },
      showSpineNav: { type: Boolean, default: false },
      disabled  : {type: Boolean, default: false },
      fluid     : {type: Boolean, default: false },
      receiptNavLabel: { type: String, default: 'Receipt' },
      exitNavLabel: { type: String, default: 'Cancel' },
      emphasizeReceipt: { type: Boolean, default: false },

    },
    components: {
      CalendarDay
    },
    watch     : {
      orderDate(newVal, oldval) {
        this.makeDateNames();
      }
    },
    computed  : {
      exitNavIsCancel() {
        const label = String(this.exitNavLabel || '').toLowerCase();
        return label === 'cancel' || label === 'discard';
      },
      frameStyle() {
        if (this.fluid) {
          return `background: ${this.color}; border: 2px solid ${this.color}; --dh-day-accent: ${this.color}; --meal-chrome-dow: ${MEAL_CALENDAR_CHROME_DOW};`;
        }
        let style = "background: " + this.color +
                    ";border-bottom: 2x solid " + this.color +
                    ";border-top: 2px solid " + this.color +
                    ";border-left: 50px solid " + this.color + ";";
        return style;
      },
      h3style() {
        return "color: " + this.textColor + ";";
      },
      textColorStyle() {
        return "color:" + this.textColor + ";";
      },
      bodyStyle() {
        let style = "";
        if( this.disabled === true ) {
          style = "background:#aaa;";
        }
        return style;
      },
      bodySeperatorStyle() {
        return "background:" + this.color +
               ";color:" + this.textColor + ";";
      },
      footerStyle() {
        return "";
      },
      orderQtyByItemNumber() {
        const map = {};
        (this.orderItems || []).forEach((line) => {
          if (line && line.itemNumber != null) {
            map[line.itemNumber] = line.qty || 0;
          }
        });
        return map;
      }
    },
    data() {
      return {
        monthName  : "",
        dayName    : "",
        dayAbbrev  : "",
        dayNumber  : 0,
        borderTitle: this.defaultDayName()
      }
    },
    mounted() {
      this.makeDateNames();
      if(this.title !== "") {
        this.borderTitle = this.title;
      }
    },
    methods   : {
      currency(c) {
        return Currency(c);
      },
      moment(d) {
        return Moment(d);
      },
      addItem(item) {
        if(this.disabled !== true ) {
          this.$emit("add", item);
        }
      },
      addItemToOrder(item, usePriceLevel, abc) {
        let priceLevel;
        if(usePriceLevel) {
          priceLevel = this.priceLevel;
        } else {
          priceLevel = 0;
        }

        let oItem = {
          itemCategory: item.category,
          orderDate   : this.orderDate,
          itemNumber  : item.itemNumber,
          priceLevel  : priceLevel,
          qty         : 1,
          title       : item.title,
          description : item.description,
          price       : item.price[ priceLevel ],
          minChoice   : item.minChoice || 0,
          maxChoice   : item.maxChoice || 3
        }
        this.addItem(oItem);
      },
      itemQty(item) {
        return this.orderQtyByItemNumber[item.itemNumber] || 0;
      },
      formatItemPrice(item, usePriceLevel) {
        if (!item || !Array.isArray(item.price)) {
          return '';
        }
        const level = usePriceLevel ? this.priceLevel : 0;
        const amount = item.price[level];
        if (amount == null || amount === '') {
          return '';
        }
        return Currency(amount).format();
      },
      removeOneFromOrder(itemNumber) {
        if (this.disabled) {
          return;
        }
        this.$emit('remove', itemNumber);
      },
      defaultDayName() {
        return this.moment(this.orderDate).format('dddd');
      },
      makeDateNames() {
        this.dayNumber = this.moment(this.orderDate).format('D');
        this.dayAbbrev = this.moment(this.orderDate).format('ddd').toUpperCase();
        this.monthName = this.moment(this.orderDate).format('MMMM');
        this.dayName = this.moment(this.orderDate).format('dddd');

        if(this.title !== "") {
          this.borderTitle = this.title;
        } else {
          this.borderTitle = this.defaultDayName();
        }
      },
      frameClicked() {
        this.$emit("click", this.title);
      }
    }
  }
</script>
<style scoped lang="scss">

  .scale-out-center {
    -webkit-animation: scale-out-center 0.5s cubic-bezier(0.550, 0.085, 0.680, 0.530) both;
            animation: scale-out-center 0.5s cubic-bezier(0.550, 0.085, 0.680, 0.530) both;
  }

/**
 * ----------------------------------------
 * animation scale-out-center
 * ----------------------------------------
 */
@-webkit-keyframes scale-out-center {
  0% {
    -webkit-transform: scale(1);
            transform: scale(1);
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(0);
            transform: scale(0);
    opacity: 1;
  }
}
@keyframes scale-out-center {
  0% {
    -webkit-transform: scale(1);
            transform: scale(1);
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(0);
            transform: scale(0);
    opacity: 1;
  }
}


  .dh-frame {
    float: left;
    margin: 1em;
    border-radius: 1em;
    padding: 3px;
    height: 600px;
    width: 398px;
    min-height: 500px;
    min-width: 300px;
  }

  .dh-frame-title {
    letter-spacing: 4px;
    position: absolute;
    top: 50%;
    left: 0;
    margin-left: -25px;
    transform: translateX(-50%) translateY(-50%) rotate(270deg);
  }

  .dh-day-number {
    position: absolute;
    height: 48px;
    width: 48px;
    border: 3px solid white;
    top: -12px;
    left: -48px;
    border-radius: 50%;
    background: #ff0202;
    color: white;
    text-align: center;
    font-size: 2em;
    font-weight: 800;
  }

  .dh-body {
    position: absolute;
    border-radius: .75em;
    top: 2px;
    left: 2px;
    height: 592px;
    width: 342px;

    background: #eee;
    vertical-align: middle;
    display: table-cell;
    padding: 2px;
    overflow-y: auto;
  }

  .dh-item {
    cursor: pointer;
    padding-left: 1%;
    padding-right: 1%;
    margin: 0;
    background: transparent;
    -webkit-tap-highlight-color: transparent;

    &:focus,
    &:active,
    &:focus-visible {
      outline: none;
      background: transparent;
    }
  }

  // Desktop-only hover — sticky :hover on touch looks like a false "selected" state
  @media (hover: hover) and (pointer: fine) {
    .dh-item:hover {
      background: #ddd;
    }
  }

  .dh-item-title {
    white-space: pre-line;
    text-align: center;
    font-weight: 500;
    font-size: 1em;
    line-height: .75em;
    padding-bottom: .5em;

  }

  .dh-item-description {
    text-overflow: ellipsis;
    width: 100%;
    white-space: pre-line;
    text-align: center;
    font-size: .90em;
    line-height: 1em;
    // margin-top: -4%;
    margin-top:-.1em;
    padding-bottom: 1em;
  }

  .dh-category-title {
    display: block;
    border-radius: .5em;
    text-align: center;
    font-weight: 600;
    font-size: 1.25em;
    padding: 4px;
    margin-bottom: .5em;
  }

  .dh-frame--fluid {
    float: none;
    width: 100%;
    max-width: 100%;
    margin: 0;
    min-width: 0;
    height: auto;
    min-height: 24rem;
    position: relative;
    display: grid;
    grid-template-columns: 3rem minmax(0, 1fr);
    gap: 0.45rem;
    padding: 0.5rem;
    box-sizing: border-box;

    .dh-frame-spine {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      gap: 0.4rem;
      grid-column: 1;
      grid-row: 1;
      min-height: 100%;
      padding: 0.15rem 0 0.35rem;
    }

    .dh-spine-nav {
      display: none;
      flex-direction: column;
      align-items: stretch;
      gap: 0.4rem;
      width: 100%;
      padding: 0.2rem 0 0.15rem;
    }

    .dh-spine-nav__btn {
      width: 100%;
      min-height: 2.35rem;
      padding: 0.4rem 0.2rem;
      border: 1px solid rgba(0, 0, 0, 0.18);
      border-radius: 0.35rem;
      background: #fff;
      color: #1f2a35;
      font-size: 0.62rem;
      font-weight: 800;
      line-height: 1.2;
      letter-spacing: 0;
      text-transform: uppercase;
      white-space: normal;
      word-break: keep-all;
      overflow-wrap: normal;
      hyphens: none;
      cursor: pointer;

      &--cancel {
        color: #7f1d1d;
        border: 1.5px solid #922b21;
        background: #fff;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
      }

      &--done {
        color: #1f2a35;
        border: 1.5px solid rgba(31, 42, 53, 0.35);
        background: #fff;
      }

      &--review {
        color: #fff;
        border: 1.5px solid rgba(0, 0, 0, 0.12);
        background: var(--dh-day-accent, #2a7f9e);
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.18);
      }
    }

    &.dh-frame--spine-nav {
      @media (max-width: 1199px) {
        grid-template-columns: 3.85rem minmax(0, 1fr);

        .dh-spine-nav {
          display: flex;
        }

        .dh-mini-day {
          width: 2.65rem;
        }

        .dh-mini-day__dow {
          font-size: 0.58rem;
          padding: 0.24rem 0.1rem;
        }

        .dh-mini-day__num {
          font-size: 1.15rem;
          padding: 0.22rem 0.1rem 0.28rem;
        }

        .dh-frame-title--bookend {
          font-size: 1rem;
        }
      }
    }

    .dh-frame-title--bookend {
      position: static;
      margin: 0;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      writing-mode: vertical-rl;
      transform: rotate(180deg);
      font-weight: 800;
      font-size: 1.2rem;
      letter-spacing: 0.04em;
      text-transform: capitalize;
      line-height: 1.05;
      white-space: nowrap;
      opacity: 0.92;
    }

    .dh-frame-main {
      position: relative;
      grid-column: 2;
      grid-row: 1;
      min-width: 0;
      min-height: 22rem;
    }

    .dh-day-theme {
      margin: 0 0 0.55rem;
      padding: 0.55rem 0.65rem;
      border-radius: 0.45rem;
      background: #fff;
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
      border-left: 3px solid var(--dh-day-accent, #2a7f9e);

      &__title {
        margin: 0;
        font-size: 0.95rem;
        font-weight: 700;
        line-height: 1.3;
        color: #1f2a35;
      }

      &__desc {
        margin: 0.3rem 0 0;
        font-size: 0.86rem;
        font-weight: 500;
        line-height: 1.45;
        color: #3d4f5f;
        white-space: pre-wrap;
      }
    }

    .dh-mini-day {
      flex-shrink: 0;
      width: 2.65rem;
      border-radius: 0.4rem;
      overflow: hidden;
      background: #fff;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
      text-align: center;
      line-height: 1;

      &__dow {
        display: block;
        background: var(--meal-chrome-dow, #2e3d4f);
        color: #fff;
        font-size: 0.65rem;
        font-weight: 800;
        letter-spacing: 0.08em;
        padding: 0.32rem 0.15rem;
      }

      &__num {
        display: block;
        color: var(--dh-day-accent, #333);
        font-size: 1.4rem;
        font-weight: 800;
        padding: 0.3rem 0.15rem 0.36rem;
      }
    }

    .dh-body {
      position: relative;
      top: auto;
      left: auto;
      width: 100%;
      min-width: 0;
      height: auto;
      min-height: 22rem;
      max-height: 38rem;
      display: block;
      margin-top: 0;
      padding: 0.5rem;
      box-sizing: border-box;
    }

    .dh-item {
      padding-left: 0.55rem;
      padding-right: 0.35rem;
      list-style: none;
    }

    .dh-item-title {
      line-height: 1.25;
      flex: 1 1 auto;
      min-width: 0;
      text-align: left;
      font-weight: 800;
      padding-bottom: 0;
    }

    .dh-item-description {
      text-align: left;
      padding-left: 1em;
      padding-right: 0.25rem;
      padding-top: 0.05rem;
      padding-bottom: 0.55rem;
      margin-top: 0;
      line-height: 1.3;
      font-size: 0.88em;
      white-space: pre-line;
      list-style: none;
    }

    .dh-item-price {
      flex-shrink: 0;
      font-weight: 900;
      font-size: 0.92em;
      color: #1f2a35;
      text-align: right;
      white-space: nowrap;
      line-height: 1.25;
    }

    .dh-item-head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 0.5rem;
      list-style: none;
      padding-bottom: 0.08rem;
    }

    .dh-item-qty {
      display: inline-flex;
      align-items: center;
      gap: 0.25rem;
      flex-shrink: 0;
    }

    .dh-item-qty__btn {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 1.5rem;
      height: 1.5rem;
      padding: 0;
      border: 1px solid rgba(0, 0, 0, 0.2);
      border-radius: 999px;
      background: #fff;
      color: #1f2a35;
      font-size: 1rem;
      font-weight: 700;
      line-height: 1;
      cursor: pointer;
    }

    .dh-item-qty__count {
      min-width: 1.75rem;
      padding: 0.15rem 0.4rem;
      border-radius: 999px;
      background: var(--dh-day-accent, #2a7f9e);
      color: #fff;
      font-size: 0.78rem;
      font-weight: 800;
      text-align: center;
    }

    .dh-item--in-order {
      border-radius: 0.45rem;
      background: rgba(255, 255, 255, 0.92);
      box-shadow: inset 0 0 0 2px var(--dh-day-accent, #2a7f9e);

      .dh-item-title {
        color: #1f2a35;
      }
    }

    .dh-category-title {
      font-size: 1rem;
      font-weight: 700;
      line-height: 1.25;
      padding: 0.4rem 0.5rem;
      white-space: normal;
    }
  }


  .dh-counter {
    left: -18px;
    bottom: 0px;

    position: absolute;
    height: 80px;
    width: 80px;
    border-radius: 1em;

    span:first-child {
      position: absolute;
      bottom: 4px;
      left: 14px;
      font-size: 1em;
      vertical-align: bottom;
      text-align: center;
    }

    span:nth-child(2) {
      position: absolute;
      bottom: 14px;
      left: 25px;
      font-size: 3em;
      font-weight: 900;
    }

  }


</style>


